/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import { Stack, Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Popconfirm from "components/Popconfirm/Popconfirm";
import { format } from "date-fns";

const approveButtonSx = {
    borderRadius: "20px",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.75rem",
    px: 1.5,
    py: 0.5,
    background: "linear-gradient(135deg, #2ecc71 0%, #27ae60 100%)",
    color: "#fff",
    boxShadow: "0 2px 8px rgba(46,204,113,0.35)",
    border: "none",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
        background: "linear-gradient(135deg, #27ae60 0%, #1e8449 100%)",
        boxShadow: "0 4px 14px rgba(46,204,113,0.45)",
        transform: "translateY(-1px)",
    },
    "&:active": { transform: "translateY(0)", boxShadow: "0 2px 6px rgba(46,204,113,0.3)" },
};

const rejectButtonSx = {
    borderRadius: "20px",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.75rem",
    px: 1.5,
    py: 0.5,
    background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
    color: "#fff",
    boxShadow: "0 2px 8px rgba(231,76,60,0.35)",
    border: "none",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
        background: "linear-gradient(135deg, #c0392b 0%, #96281b 100%)",
        boxShadow: "0 4px 14px rgba(231,76,60,0.45)",
        transform: "translateY(-1px)",
    },
    "&:active": { transform: "translateY(0)", boxShadow: "0 2px 6px rgba(231,76,60,0.3)" },
};

export default function data({ reviews = [], onApprove, onRejectClick }) {
    console.log("reviews in table data:", reviews);
    const rows = reviews.map((mistake) => ({
        dealer: mistake?.dealer?.name ?? "-",
        type: mistake?.type ?? "-",
        mistake: mistake?.mistakeRelation?.name ?? "-",
        manager: mistake?.user?.name ?? "-",
        date: mistake.date
            ? format(new Date(new Date(mistake.date).toISOString().split("T")[0]), "dd.MM.yyyy")
            : "-",
        time: mistake.time ?? "-",
        reviewComment: mistake.review_comment ?? "-",
        action: (
            <Stack direction="row" spacing={1} alignItems="center">
                <Popconfirm
                    title="Approve this review?"
                    confirmText="Approve"
                    confirmColor="success"
                    onConfirm={() => onApprove(mistake.id)}
                >
                    <Button variant="contained" disableElevation sx={approveButtonSx}
                        startIcon={<CheckIcon sx={{ fontSize: "14px !important" }} />}
                    >
                        Approve
                    </Button>
                </Popconfirm>
                <Button
                    variant="contained"
                    disableElevation
                    sx={rejectButtonSx}
                    startIcon={<CloseIcon sx={{ fontSize: "14px !important" }} />}
                    onClick={() => onRejectClick(mistake.id)}
                >
                    Reject
                </Button>
            </Stack>
        ),
    }));

    return {
        columns: [
            { Header: "Dealer", accessor: "dealer", align: "left" },
            { Header: "Type", accessor: "type", align: "left" },
            { Header: "Mistake", accessor: "mistake", align: "left" },
            { Header: "Manager", accessor: "manager", align: "left" },
            { Header: "Date", accessor: "date", align: "left" },
            { Header: "Time", accessor: "time", align: "left" },
            { Header: "Review Comment", accessor: "reviewComment", align: "left" },
            { Header: "Actions", accessor: "action", align: "center" },
        ],
        rows,
    };
}
